/* Gentle Beauty — WebMCP (agentic browsing) support.
   Declarative: annotates key forms with toolname / tooldescription / toolparamdescription.
   Imperative: registers read-only store tools + add-to-cart for AI agents when the browser supports WebMCP.
   Toggle: Theme settings → GB · SEO & AI visibility → WebMCP. */
(function () {
  'use strict';
  var cfg = window.GBConfig || {};
  var agentic = cfg.agentic || {};
  if (agentic.enabled === false) return;

  var root = (cfg.routes && cfg.routes.root) || '/';
  var base = root.replace(/\/$/, '');

  function describeField(el, text) {
    if (el && text && !el.hasAttribute('toolparamdescription')) el.setAttribute('toolparamdescription', text);
  }
  function labelFor(el) {
    var t = '';
    if (el.id) { var l = document.querySelector('label[for="' + el.id + '"]'); if (l) t = l.textContent; }
    if (!t) t = el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.name || '';
    return t.replace(/\s+/g, ' ').trim();
  }
  function annotate(form, name, description, fields) {
    if (!form || form.hasAttribute('toolname')) return;
    var inputs = form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (!el.name) return; // incomplete schema → leave the form unannotated rather than publish an invalid tool
      var key = el.name;
      describeField(el, (fields && fields[key]) || labelFor(el));
    }
    /* description first: the browser validates the tool as soon as toolname appears */
    form.setAttribute('tooldescription', description);
    form.setAttribute('toolname', name);
  }

  function annotateForms(scope) {
    var forms = (scope || document).querySelectorAll('form');
    Array.prototype.forEach.call(forms, function (form) {
      var action = (form.getAttribute('action') || '').toLowerCase();
      var tags = form.querySelector('input[name="contact[tags]"]');
      var tagVal = tags ? (tags.value || '').toLowerCase() : '';
      if (action.indexOf('/search') > -1 && form.querySelector('[name="q"]')) {
        annotate(form, 'search_store', agentic.searchDescription || 'Search Gentle Beauty products, collections, journal articles and pages by keyword.', { q: 'Search keywords, e.g. "foundation for warm skin" or "retinol serum".' });
      } else if (tagVal.indexOf('newsletter') > -1) {
        annotate(form, 'subscribe_newsletter', agentic.newsletterDescription || 'Subscribe an email address to the Gentle Beauty newsletter.', { 'contact[email]': 'Email address of the person who explicitly asked to subscribe.' });
      } else if (tagVal.indexOf('back-in-stock') > -1) {
        annotate(form, 'notify_back_in_stock', agentic.notifyDescription || 'Ask to be emailed when a sold-out product is available again.', { 'contact[email]': 'Email address to notify when the product is back in stock.' });
      } else if (form.querySelector('input[name="form_type"][value="contact"]') && form.querySelector('textarea')) {
        annotate(form, 'contact_store', agentic.contactDescription || 'Send a message to Gentle Beauty customer care.', {
          'contact[name]': 'Full name of the customer.',
          'contact[email]': 'Email address for the reply.',
          'contact[body]': 'The message or question for customer care.'
        });
      }
    });
  }

  function mc() { return document.modelContext || navigator.modelContext || null; }

  function registerTools() {
    var ctx = mc();
    if (!ctx || typeof ctx.registerTool !== 'function' || registerTools.done) return;
    registerTools.done = true;
    var json = function (url, opts) { return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, opts || {})).then(function (r) { return r.json(); }); };
    var money = function (cents) { return window.GB && GB.formatMoney ? GB.formatMoney(cents) : String(cents / 100); };
    var tools = [
      {
        name: 'search_products',
        description: 'Search the Gentle Beauty catalog and return matching products with price, availability and URL.',
        inputSchema: { type: 'object', properties: { query: { type: 'string', description: 'Search keywords.' }, limit: { type: 'number', description: 'Maximum results (1-10).' } }, required: ['query'] },
        annotations: { readOnlyHint: true },
        execute: function (input) {
          var limit = Math.max(1, Math.min(10, Number(input.limit) || 6));
          return json(base + '/search/suggest.json?q=' + encodeURIComponent(input.query) + '&resources[type]=product&resources[limit]=' + limit)
            .then(function (d) {
              var items = (d.resources && d.resources.results && d.resources.results.products) || [];
              return JSON.stringify(items.map(function (p) { return { title: p.title, handle: p.handle, price: p.price, available: p.available, url: location.origin + p.url.split('?')[0] }; }));
            });
        }
      },
      {
        name: 'get_product',
        description: 'Get details for one product by handle: description, variants, prices and availability.',
        inputSchema: { type: 'object', properties: { handle: { type: 'string', description: 'Product handle, e.g. "age-defying-serum".' } }, required: ['handle'] },
        annotations: { readOnlyHint: true },
        execute: function (input) {
          return json(base + '/products/' + encodeURIComponent(input.handle) + '.js').then(function (p) {
            return JSON.stringify({
              title: p.title, vendor: p.vendor, type: p.type, url: location.origin + p.url,
              description: (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 1200),
              variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: money(v.price), available: v.available }; })
            });
          });
        }
      },
      {
        name: 'get_cart',
        description: 'Read the current shopping bag: items, quantities and subtotal.',
        inputSchema: { type: 'object', properties: {} },
        annotations: { readOnlyHint: true },
        execute: function () {
          return json(base + '/cart.js').then(function (c) {
            return JSON.stringify({ item_count: c.item_count, subtotal: money(c.total_price), items: c.items.map(function (i) { return { title: i.product_title, variant: i.variant_title, quantity: i.quantity, line_price: money(i.final_line_price) }; }) });
          });
        }
      },
      {
        name: 'add_to_cart',
        description: 'Add a product variant to the shopping bag. Only use when the shopper has asked to add it.',
        inputSchema: { type: 'object', properties: { variant_id: { type: 'number', description: 'Variant ID from get_product.' }, quantity: { type: 'number', description: 'Quantity to add (default 1).' } }, required: ['variant_id'] },
        annotations: { readOnlyHint: false, consequentialHint: true },
        execute: function (input) {
          var qty = Math.max(1, Number(input.quantity) || 1);
          var run = window.GB && GB.cart ? GB.cart.add({ id: input.variant_id, quantity: qty }) : json(base + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: input.variant_id, quantity: qty }] }) });
          return Promise.resolve(run).then(function () { return 'Added ' + qty + ' item(s) to the bag.'; });
        }
      }
    ];
    tools.forEach(function (t) {
      try {
        var r = ctx.registerTool(t);
        if (r && typeof r.catch === 'function') r.catch(function () {});
      } catch (e) { /* ignore unsupported shapes */ }
    });
  }

  function boot() { if (agentic.declarative) annotateForms(document); registerTools(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (agentic.declarative) annotateForms(e.target); });
  document.addEventListener('gb:quickview:loaded', function (e) { if (agentic.declarative && e.detail && e.detail.el) annotateForms(e.detail.el); });
})();
